/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Event_Group_MetadataInputs */

const en_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group Metadata`)
};

const fr_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées du groupe d'événements`)
};

const de_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen-Metadaten`)
};

const it_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati del gruppo di eventi`)
};

const ru_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные группы событий`)
};

const es_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos del grupo de eventos`)
};

const zh_cn2_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组元数据`)
};

const ja_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループメタデータ`)
};

const hi_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह मेटाडेटा`)
};

const pt_pt2_metadata_merge_event_group_metadata = /** @type {(inputs: Metadata_Merge_Event_Group_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados do grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Event Group Metadata" |
*
* @param {Metadata_Merge_Event_Group_MetadataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_event_group_metadata = /** @type {((inputs?: Metadata_Merge_Event_Group_MetadataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Event_Group_MetadataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_event_group_metadata(inputs)
	if (locale === "de") return de_metadata_merge_event_group_metadata(inputs)
	if (locale === "it") return it_metadata_merge_event_group_metadata(inputs)
	if (locale === "ru") return ru_metadata_merge_event_group_metadata(inputs)
	if (locale === "es") return es_metadata_merge_event_group_metadata(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_event_group_metadata(inputs)
	if (locale === "ja") return ja_metadata_merge_event_group_metadata(inputs)
	if (locale === "hi") return hi_metadata_merge_event_group_metadata(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_event_group_metadata(inputs)
	return en_metadata_merge_event_group_metadata(inputs)
});